/* istanbul ignore file */


import axiosObj from '../../../http/index';
import ActionTypes from "../../constants";
import { Dispatch } from 'redux';
import { currentTabNameAction, makeProjectsAction, makeProjectsActionType, deleteProjectTypes, 
    deletedProjectAction, restoreProjectStateTypes, restoreProjectAction, 
    configParams, ProjectsCountAction, removeProjectFromCartAction  } from '../action';

const LIMIT = 50;
/* global photoOrg */

declare var photoOrg:any;

function getConfig(){
    return photoOrg.config;
}

const config = getConfig();
const baseURL = config.projects;
const logger = photoOrg.clientLogger;
const enablePermanentDelete = config.enablePermanentDelete;

const getXApiKeyHeader = (): Record<string, string> => {
    try {
        const key = photoOrg && photoOrg.config && photoOrg.config.xApiKey;
        return key ? { 'X-API-Key': key } : {};
    } catch(e) { return {}; }
};


const prepareParamsFromConfig= (params: configParams) => {
    params['excludeSkus']= config.exclude_project_skus;
    if (config.sourceGroup && config.sourceGroup.length > 0) {
        params["sourceGroup"] = config.sourceGroup
    }
    if(!config.show_dp_projects){
        params["excludeTypes"] = "documentprint";
    }    
    if(config.projects_portability){
        params["includePortable"] = "true"
    }

    return params;
}

export const projectsCount = (tabName: makeProjectsActionType | ActionTypes.SOFT_DELETED) => {
    const type= ActionTypes.GET_COUNT;
    tabName =  (tabName === ActionTypes.DELETED) ? ActionTypes.SOFT_DELETED : tabName;

    return async (dispatch: Dispatch<ProjectsCountAction>,getState: any) => {
        var url = "";
        try{   
            //https://projects.sf-qa.com/v2/project/count?state=saved&includePortable=true&sourceGroup=sf-store&excludeSkus=CommerceProduct_90950,CommerceProduct_23152&excludeTypes=documentprint&format=false
            var params = {        
                state: tabName,
                format: false        
            }
            
            prepareParamsFromConfig(params);

            url = '/project/count?'+(new URLSearchParams(params as any).toString()); 
            let {data} = await axiosObj.get(`${baseURL}${url}`, { headers: getXApiKeyHeader() })   
                
            dispatch<ProjectsCountAction>({type, payload: {tabName,data}})
        }catch(error){
            logger.error({description: "LIBRARY:ActionCreator:makeProjectsCountCall:Exception", errorCode: "LIBRARY:MYPROJECTS", url: url, err_desc: error.message, err_stack: error.stack});
        }
    }
}


export const makeProjectsCall = (type: makeProjectsActionType, queryStart: number) => {
    const state = ((type === ActionTypes.DELETED) ? ActionTypes.SOFT_DELETED : type) as makeProjectsActionType | ActionTypes.SOFT_DELETED;
    
    return async (dispatch: Dispatch<makeProjectsAction>, getState:any) => {
        var url = "";
        try{
            var params = {
                queryLimit: LIMIT,
                querySortKeys: "updateDate-",  
                state,     
                format: false,
                filter: "saved"           
            }
        
            prepareParamsFromConfig(params);
        
            if(queryStart > 0){
                params["queryStart"]=queryStart
            }
            url = '/project?'+(new URLSearchParams(params as any).toString());   
            const {data} = await axiosObj.get(`${baseURL}${url}`, { headers: getXApiKeyHeader() })  
                
            dispatch<makeProjectsAction>({type, payload: data})
        
        }catch(error){
            logger.error({description: "LIBRARY:ActionCreator:makeProjectsCall:Exception", errorCode: "LIBRARY:MYPROJECTS", url: url, type: type, err_desc: error.message, err_stack: error.stack});
        }
    }
} 

export const delProject = (projectState: deleteProjectTypes, projectId: string) => {
    let type, state;
    if(projectState === ActionTypes.ARCHIVED){
        type = ActionTypes.DEL_PURCHASED_PROJECT
        state = ActionTypes.PURCHASED
    }else{
        type = ActionTypes.DEL_SAVED_PROJECT
        state= ActionTypes.SAVED
    }     
    return async (dispatch: Dispatch<deletedProjectAction>) => {
        //https://projects.sf-qa.com/v2/project/17164250060
        let queryParam = (state === ActionTypes.SAVED && enablePermanentDelete) ? "?permanentDelete=true":"";
        let url = "/project/" + projectId + queryParam
        try{
             await axiosObj.delete(`${baseURL}${url}`, { headers: getXApiKeyHeader() })

            dispatch<deletedProjectAction>({type, payload: {projectId}})
        } catch(error){
            logger.error({description: "LIBRARY:ActionCreator:makeDeleteProjectCall:Exception", url: url, errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
        }
    }
}



export const restoreProject = (projectId: string, projectState: restoreProjectStateTypes) => {
    var type = ActionTypes.RESTORE_DELETED_PROJECT as ActionTypes.RESTORE_DELETED_PROJECT
    return async (dispatch: Dispatch<restoreProjectAction>) => {
        //https://projects.sf-qa.com/v2/project/undelete/16450639060?_=1619342588396
        var url = "/project/undelete/" + projectId;
        try{   
             await axiosObj.get(`${baseURL}${url}`, { headers: getXApiKeyHeader() }) 

            dispatch<restoreProjectAction>({type, payload: {projectId, projectState}})    
        } catch(error){
            logger.error({description: "LIBRARY:ActionCreator:makeRestoreProjectCall:Exception", url: url, errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
        }
    }
}


export const removeProjectFromCart = (project: {id, editProjectUrl, orderId}) => {
    var type = ActionTypes.REMOVE_PROJECT_FROM_CART as ActionTypes.REMOVE_PROJECT_FROM_CART
    return async (dispatch: Dispatch<removeProjectFromCartAction>) => {
            //https://projects.sf-qa.com/v2/project/undelete/16450639060?_=1619342588396
            try{  
                //delete axiosObj.defaults.headers.common["gsid"];
                var reqObj = {
                    method: 'POST',
                    url: `${photoOrg.config.cart_url}/api/v1/removeproject`,
                    data: {project:[project.id],orderId:project.orderId},
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', ...getXApiKeyHeader() }
                }
                axiosObj.request(reqObj).then( () => {
                    // @ts-ignore
                    photoOrg.Util.trackLinksAndButtons('Edit Projects','projectsPage');
                    window.location.href = project.editProjectUrl;
                } ).catch( ( error ) => {
                    console.log( error );
                } )                 
                //axiosObj.defaults.headers.common["gsid"] = photoOrg.oauthInfo.GSID;  
            }catch(error){
                logger.error({description: "LIBRARY:ActionCreator:makeRemoveProjectFromCartCall:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
                window.location.href = project.editProjectUrl;
            }     
            dispatch<removeProjectFromCartAction>({type, payload: {project} })
    }
}

export const resetGivenReduxKeyData = (key) => {
    return {type: ActionTypes.RESET_STORE_DATA,payload: key}
}



export const currentTabName = (tabName: makeProjectsActionType) => {
    return async (dispatch: Dispatch<currentTabNameAction>) => {
        dispatch<currentTabNameAction>({type: ActionTypes.CURRENT_TAB_NAME, payload: tabName})
    }
}

// export const deletedProjects = (queryStart) => {
//     const state =  ActionTypes.SOFT_DELETED
//     const type= ActionTypes.DELETED  
//     return (dispatch,getState) => {
//         makeProjectsCall(state,type,dispatch,queryStart)
//     }
// }